// src/components/chatPolicy/MultiSelectChips.jsx
// Multi-select tipo "tag input" sobre una lista fija (puestos/unidades).
// Click en el dropdown añade; click en el chip lo quita.
import React, { useMemo, useState } from 'react';
import { Form, Badge } from 'react-bootstrap';

export default function MultiSelectChips({ options = [], value = [], onChange, placeholder = 'Buscar…' }) {
    const [q, setQ] = useState('');
    const [open, setOpen] = useState(false);

    const filtered = useMemo(() => {
        const sel = new Set(value);
        const ql = q.trim().toLowerCase();
        return options.filter(o => !sel.has(o) && (!ql || o.toLowerCase().includes(ql))).slice(0, 30);
    }, [options, value, q]);

    const add = (v) => { onChange?.([...value, v]); setQ(''); };
    const remove = (v) => onChange?.(value.filter(x => x !== v));

    return (
        <div style={{ position: 'relative' }}>
            {value.length > 0 && (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginBottom: 6 }}>
                    {value.map(v => (
                        <Badge key={v} bg="secondary" style={{ padding: '6px 8px', fontWeight: 500 }}>
                            {v}
                            <span role="button" onClick={() => remove(v)} style={{ cursor: 'pointer', marginLeft: 6 }}>✕</span>
                        </Badge>
                    ))}
                </div>
            )}
            <Form.Control
                size="sm"
                placeholder={placeholder}
                value={q}
                onChange={e => { setQ(e.target.value); setOpen(true); }}
                onFocus={() => setOpen(true)}
                onBlur={() => setTimeout(() => setOpen(false), 150)}
                style={{ borderRadius: 8 }}
            />
            {open && filtered.length > 0 && (
                <div style={{
                    position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 100,
                    background: 'var(--c-card, #fff)', border: '1px solid var(--c-border, #e5e7eb)',
                    borderRadius: 8, marginTop: 4, maxHeight: 180, overflowY: 'auto',
                    boxShadow: '0 4px 12px rgba(0,0,0,.1)',
                }}>
                    {filtered.map(o => (
                        <div key={o} onMouseDown={() => add(o)} style={{
                            padding: '6px 10px', cursor: 'pointer', fontSize: 13, borderBottom: '1px solid var(--c-border, #f1f5f9)',
                        }}
                        onMouseEnter={e => e.currentTarget.style.background = 'rgba(37,99,235,.08)'}
                        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                        >
                            {o}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
